import { getCarwashDisplayName, type CarwashShop } from "./amapCarwashDemo";

export type CarwashModeStage = "idle" | "prompt" | "active";

export interface CarwashModeState {
  couponLabel: string;
  priceLabel: string;
  shopName: string;
  stage: CarwashModeStage;
  waitMinutes: number;
}

export const idleCarwashMode: CarwashModeState = {
  couponLabel: "",
  priceLabel: "",
  shopName: "",
  stage: "idle",
  waitMinutes: 0
};

export function createCarwashModePrompt(shop: CarwashShop): CarwashModeState {
  return {
    couponLabel: shop.couponLabel,
    priceLabel: shop.priceLabel,
    shopName: getCarwashDisplayName(shop),
    stage: "prompt",
    waitMinutes: shop.waitMinutes
  };
}

export function activateCarwashMode(session: CarwashModeState): CarwashModeState {
  if (session.stage === "idle") {
    return session;
  }

  return {
    ...session,
    stage: "active"
  };
}
